import React from "react";
import '../../index.css';

const renderCellSatisfactionGlobale = ({ value }) => {
    const styles = {
        padding: "5px 10px",
        borderRadius: "5px",
    }

    let classe;
    if (value === null) {
        classe = "bg0";
    } else if (value < 20) {
        classe = "bg1";
    } else if (value < 40) {
        classe = "bg2";
    } else if (value < 60) {
        classe = "bg3";
    } else if (value < 80) {
        classe = "bg5";
    } else if (value < 100) {
        classe = "bg6";
    } else if (value >= 100) {
        classe = "bg7";
    }

    return (
        <div>
            <span className={classe} style={styles}>
                { value ? value + " %" : "N/A" }
            </span>
        </div>
    );
}

export default renderCellSatisfactionGlobale;